/**
 * Storage utility functions for managing localStorage cleanup
 */

/**
 * User preference keys that should persist across logout/session expiry
 */
const USER_PREFERENCE_KEYS = [
  'feature-release-video-status',
  'lift-sidebar-state',
] as const;

/**
 * Clears localStorage while preserving user preferences
 * This is useful during logout or session expiry scenarios
 */
export const clearAuthStoragePreservingPreferences = (): void => {
  // Save user preferences
  const preservedData: Record<string, string | null> = {};
  USER_PREFERENCE_KEYS.forEach((key) => {
    preservedData[key] = localStorage.getItem(key);
  });

  // Clear all localStorage
  localStorage.clear();

  // Restore user preferences
  Object.entries(preservedData).forEach(([key, value]) => {
    if (value !== null) {
      localStorage.setItem(key, value);
    }
  });
};

/**
 * Alternative approach: Clear only auth-related keys (more conservative)
 */
export const clearAuthStorageSelectively = (): void => {
  const authKeysToRemove = [
    'authKey',
    'auth-storage',
    'user-info',
    'tenant-storage',
  ];

  authKeysToRemove.forEach((key) => {
    localStorage.removeItem(key);
  });
};
